const EN = {
    title: 'Tarjetas',
    table: {
        title: 'Listado de tarjetas',
        columns: {
            id: 'ID Interno',
            gpaccount: 'Cuenta GP',
            created: 'Fecha Alta',
            type: 'Tipo',
            lastFour: 'Últimos 4',
            client: 'Cliente',
            status: 'Estado',
            identification: 'INE'
        },
        status: {
            title: 'Estado',
            1: 'Normal',
            2: 'Baja',
            3: 'Reimpresión',
            4: 'Denunciada',
            5: 'Renovada',
            6: 'Bloqueada',
            7: 'Inhabilitada',
            8: 'Denunciada IVR',
            9: 'Bloqueada IVR',
            10: 'Vencida'
        },
    },
    details: {
        inputs: {
            limit: 'Limite total',
            availableLimit: 'Limite disponible',
            closingDate: 'Fecha de cierre',
            dueDate: 'Fecha de vencimiento',
            nextClosingDate: 'Próximo cierre',
            nextDueDate: 'Próximo vencimiento',
            pendingPayment: 'Pagos pendientes',
            virtualCard: 'Tarjeta Virtual'
        }
    },
    payment: {
        title: 'Informe de pago',
        description: 'Tarjeta terminada en ',
        amount: 'Monto',
        success: {
            title: 'Pago exitoso',
            description: 'El informe del pago se ha realizado con éxito.'
        },
        fail: {
            title: 'Pago fallido',
            description: 'El informe del pago ha fallado.'
        }
    }
};

export default EN;
